import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Logo from "../../../images/logo2.jpg";
import "../ReLoginPage.css";

// Modal Component
const Modal = ({ message, onClose }) => {
  if (!message) return null;

  return (
    <div className="modal">
      <div className="modal-content">
        <p>{message}</p>
        <button className="close-button" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

const Login = () => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!mobileNumber || !password) {
      setError("Please enter both mobile number and password.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await axios.post(
        "https://todaylocal.in/api/api/login/verify",
        {
          mobileNumber,
          password,
        }
      );

      if (response.data?.status === "success") {
        // ✅ Save login details
        localStorage.setItem("sessiontoken", response.data.sessionToken);
        localStorage.setItem("reporterId", response.data.reporterId);
        localStorage.setItem("userRole", "reporter");

        // Optional modal message
        setModalMessage("Login successful!");

        // ✅ Navigate to reporter dashboard
        navigate("/reporter/dashboard");
      } else {
        setError(response.data?.error || "Invalid mobile number or password.");
      }
    } catch (error) {
      console.error("Login error:", error);
      setError("An unexpected error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSignUp = async () => {
    try {
      const response = await axios.get("https://todaylocal.in/api/api/admin/allchannels");

      if (response.data && Array.isArray(response.data)) {
        const channelNames = response.data.map((channel) => channel.name);
        localStorage.setItem("channels", JSON.stringify(channelNames));
      }

      navigate("/reporter/register");
    } catch (error) {
      console.error("Failed to fetch channels:", error);
    }
  };

  return (
    <div className="reporterlogin">
      <Modal message={modalMessage} onClose={() => setModalMessage("")} />

      <div className="login-container">
        <img src={Logo} alt="My Image" className="Re-Login-image-logo" />
        <h2>Reporter Login</h2>

        {error && <p className="error-message">{error}</p>}

        <div className="input-group">
          <label>Mobile Number</label>
          <div className="input-icon-group">
            <i className="fas fa-phone icon"></i>
            <input
              type="text"
              value={mobileNumber}
              onChange={(e) => setMobileNumber(e.target.value)}
              placeholder="Enter mobile number"
            />
          </div>
        </div>

        <div className="input-group">
          <label>Password</label>
          <div className="input-icon-group">
            <i className="fas fa-key icon"></i>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
            />
          </div>
        </div>

        <button className="login-button" onClick={handleLogin} disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </button>

        <div className="link-group">
          <button className="link-button" onClick={handleSignUp}>
            Become a reporter! Signup Now
          </button>
          <button
            className="link-button"
            onClick={() => navigate("/reporter/forgot-password")}
          >
            Forgot Password
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
